/**
 * Created by zhaoy on 19:45.
 * 修改资料
 */
import React from 'react';
import {Icon, Divider, Avatar} from "antd";
import "../recharge/RechargeDetai.css"
import {fetchGet,fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Card, WingBlank, List, Toast, Tabs, WhiteSpace, Button, Picker } from "antd-mobile";
import UploadEnclosure from "../../components/UploadEnclosure";

class ElectronicCardOnOff extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            },
            fileList: [],
            IMEI: this.props.match.params.IMEI,
        };
    }


    componentDidMount(){
        document.title = '宝贝资料'
        Toast.loading("");

       fetchGet(API.GET_ELECTRONIC_CARD,{
           IMEI: this.props.match.params.IMEI
         }).then((response)=>{
            Toast.hide();

             if(response.success){
                 this.setState({data:response.data});
             }
         }).catch((error)=>{
            Toast.hide()
             console.log("error:"+JSON.stringify(error));
         })
    }
    onChangeColor = (color) => {
        if (this.color == true) {
            return
        }

        this.isRequesting = true
        fetchPost(API.ADD_ELECTRONIC_SEX, {
            IMEI: this.props.match.params.IMEI,
            parameter: color[0],
        }, {}).then((response) => {
            console.log('response', response)
            this.isRequesting = false
            if (response.success) {
                this.isRequesting = true
                Toast.show(response.data, 1)
                // this.props.history.push("/leaveList/" + this.props.match.params.role)
                // this.props.history.push("/homePage")
                this.backTask = setTimeout(() => {
                    this.props.history.goBack();
                }, 1000)
            }
        }).catch((error) => {
            this.isRequesting = false
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
        this.setState({
        colorValue: color,
        });
     };

    render(){
        const {data, stuPhoto, fileList, IMEI} = this.state;
        const colors = [
          {
            label:
            (<div>
              <span>男</span>
            </div>),
            value: 1,
          },
          {
            label:
            (<div>
              <span>女</span>
            </div>),
            value: 2
          }
        ];
        return <div className="padding_15">


                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">宝贝头像</div>
                     </div>
                     <div  className="flex_center_vertical_end item_flex">
                         {/*<div className="span_14 color_lightGreen">1111</div>*/}
                {data.stu_photo ?
                            <img className="flex_row_center"
                                 width={78}
                                 style={{ marginLeft: '10px' ,borderRadius: '10%'}}
                                 src={data.stu_photo}
                            /> :
                            this.props.isSelect ?
                              <Avatar style={{borderRadius: '20%'}}
                                      size={30} icon='user'/> :
                              <Avatar style={{borderRadius: '20%'}}
                                      size={30} icon='user'/>
                          }
                          <span className="fileinput-button margin_left_20" style={{color: "#3680ED"}}>

                                                  {/*<input type="file" accept="image/*" capture="camera" onChange={this.uploadChange}/>*/}
                                                  <UploadEnclosure
                                                      action={API.UPLOAD_FILE}
                                                      fileList={fileList}
                                                      count={1}
                                                      multiple={false}
                                                      handlePreview={this.enclosurePreview.bind(this)}
                                                      beforeUpload={this.beforeUpload.bind(this)}
                                                      handleChange={this.handleChange.bind(this)}
                                                  /></span>
                         <Icon type="right" />
                     </div>
                 </div>
                <div className="notify-item-line"></div>


                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">宝贝姓名</div>
                     </div>
                     <div  className="flex_center_vertical_end item_flex">
                         {data.bindingStuName}
                     </div>
                 </div>
                <div className="notify-item-line"></div>

                <div onClick={()=>{
                                                 this.props.history.push('/electronicCardDataDetail/'+ IMEI+'/nickname');
                                             }}>
                                        <div className="flex_row padding_10  bg_white">
                                             <div className="flex_column">
                                                 <div className="span_14  text_bold">宝贝昵称</div>
                                             </div>
                                             <div  className="flex_center_vertical_end item_flex">
                                                 {data.nickname}<Icon type="right" />
                                             </div>
                                         </div>
                <div className="notify-item-line"></div>
                </div>

                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">宝贝性别</div>
                     </div>
                     <div  className="flex_center_vertical_end item_flex">
{data.stuSex===1?'男':'女'}
                         <Picker
                           data={colors}
                           value={this.state.colorValue}
                           cols={1}
                           onChange={this.onChangeColor}
                         >
                         <Icon type="right" />
                         </Picker>
                     </div>
                 </div>
                <div className="notify-item-line"></div>

                <div onClick={()=>{
                                                 this.props.history.push('/electronicCardDataDetail/'+ IMEI+'/phone');
                                             }}>
                                        <div className="flex_row padding_10  bg_white">
                                             <div className="flex_column">
                                                 <div className="span_14  text_bold">宝贝手机号</div>
                                             </div>
                                             <div  className="flex_center_vertical_end item_flex">
                                                 {data.sim}<Icon type="right" />
                                             </div>
                                         </div>
                <div className="notify-item-line"></div>
                </div>

                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">所属学校</div>
                     </div>
                     <div  className="flex_center_vertical_end item_flex">
                         {data.schoolName}
                     </div>
                 </div>
                <div className="notify-item-line"></div>


                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                         <div className="span_14  text_bold">所属班级</div>
                     </div>
                     <div  className="flex_center_vertical_end item_flex">
                         {data.gradeClass}
                     </div>
                 </div>
                <div className="notify-item-line"></div>

        </div>
    }

    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})

            if (fileList[0].status === 'error') {
                Toast.fail('人脸照上传失败，请重试！')
                this.setState({
                    fileList: []
                })
            } else if (fileList[0].status === 'done') {
                if(this.type == 2){
                    this.updateUserInfo(fileList[0].response.data)
                }else{
                    this.updateTeacherInfo(fileList[0].response.data)
                }
            } else if (fileList[0].status === 'uploading') {

            } else {
                Toast.hide()
            }
        }
    }

     enclosurePreview = () => {

     }
     beforeUpload = (file, fileList) => {
         Toast.loading('人脸照上传中...', 0)
     }

     uploadFile = (file) => {
         const formData = new FormData();
         formData.append('file', file);
         Toast.loading("")
         fetch(API.UPLOAD_FILE, {
             method: "POST",
             body: formData,
             mode: 'cors',
         }).then(function (response) {
             let result = response.json();
             if (response.status === 200) {
                 console.log("text:", result);
                 return result;
             } else {
                 Toast.success("上传失败！")
             }
         }).then(result => {
             if (result.success) {
                 Toast.success("上传成功！");
                 let imageUrl = result.data;
                 this.state.imageUrl = imageUrl;
                 this.setState({
                     imageUrl: imageUrl
                 });
                 if(this.type == 2) {
                     this.updateUserInfo(imageUrl)
                 }else{
                     this.updateTeacherInfo(imageUrl)
                 }
             }
         }).catch(function (ex) {
             Toast.fail("上传失败！")
         })
     }
}

export  default ElectronicCardOnOff;